export const SpeakingTests = [
  [{ title: "Read Aloud", 
    link: "/speaking/read-aloud", new: false },
    { title: "Repeat Sentence", 
      link: "/speaking/repeat-sentence", new: false },
    { title: "Describe Image", 
      link: "/speaking/describe-image", new: false },
    { title: "Re-Tell Lecture", 
      link: "/speaking/re-tell-lectures", new: false },
    {
      title: "Answer Short Question",
      link: "/speaking/answer-short-question",
      new: false,
    },
  ],
  [
    { title: "Read Aloud", 
      link: "/speaking/read-aloud", new: false },
    { title: "Repeat Sentence", 
      link: "/speaking/repeat-sentence", new: false },
    { title: "Describe Image", 
      link: "/speaking/describe-image", new: false },
    {
      title: "Respond to a Situation",
      link: "/speaking/respond-to-a-situation",
      new: true,
    },  
    {
      title: "Answer Short Question",
      link: "/speaking/answer-short-question",
      new: false,
    },
  ]
];

export const WritingTests = [
  [{
    title: "Summarize Written Text",
    link: "/writing/summarize-written-text/pte-academic",
    new: false,
  },
  { title: "Write Essay", 
    link: "/writing/write-essay", new: false },
  ],
  [
    {
      title: "Summarize Written Text",
      link: "/writing/summarize-written-text/pte-core",
      new: false,
    },
    { title: "Write Email", 
      link: "/writing/write-email", new: true },    
  ]
];

export const ReadingTests = [
  {
    title: "Reading & Writing: Fill in the Blanks",
    link: "/reading/reading-and-writing-fill-in-the-blanks",
  },
  {
    title: "Multiple Choice, Multiple Answers",
    link: "/reading/multiple-choice-choose-multiple-answer",
  },
  { title: "Re-order Paragraphs", 
    link: "/reading/re-order-paragraphs" },
  {
    title: "Reading: Fill in the Blanks",
    link: "/reading/reading-fill-in-the-blanks",
  },
  {
    title: "Multiple Choice, Single Answer",
    link: "/reading/multiple-choice-choose-single-answer",
  },
];

export const ListeningTests = [[
  {
    title: "Summarize Spoken Text",
    link: "/listening/summarize-spoken-text",
    new: false,
    ai: true,
  },
  {
    title: "Multiple Choice, Multiple Answers",
    link: "/listening/multiple-choice-choose-multiple-answer",
    new: false,
    ai: false,
  },
  {
    title: "Fill in the Blanks",
    link: "/listening/fill-in-the-blanks",
    new: false,
    ai: false,
  },
  {
    title: "Highlight Correct Summary",
    link: "/listening/highlight-correct-summary",
    new: false,
    ai: false,
  },
  {
    title: "Multiple Choice, Single Answer",
    link: "/listening/multiple-choice-choose-single-answer",
    new: false,
    ai: false,
  },
  {
    title: "Select Missing Word",
    link: "/listening/select-missing-word",
    new: false,
    ai: false,
  },
  {
    title: "Highlight Incorrect Words",
    link: "/listening/highlight-incorrect-word",
    new: false,
    ai: false,
  },
  {
    title: "Write from Dictation",
    link: "/listening/write-from-dictation",
    new: false,
    ai: true,
  },],
  [
    {
      title: "Summarize Spoken Text",
      link: "/listening/summarize-spoken-text",
      new: false,
      ai: true,
    },
    {
      title: "Multiple Choice, Multiple Answers",
      link: "/listening/multiple-choice-choose-multiple-answer",
      new: false,
      ai: false,
    },
    {
      title: "Fill in the Blanks",
      link: "/listening/fill-in-the-blanks",
      new: false,
      ai: false,
    },
    {
      title: "Multiple Choice, Single Answer",
      link: "/listening/multiple-choice-choose-single-answer",
      new: false,
      ai: false,
    },
    {
      title: "Select Missing Word",
      link: "/listening/select-missing-word",
      new: false,
      ai: false,
    },
    {
      title: "Highlight Incorrect Words",
      link: "/listening/highlight-incorrect-word",
      new: false,
      ai: false,
    },
    {
      title: "Write from Dictation",
      link: "/listening/write-from-dictation",
      new: false,
      ai: true,
    },]  
];
